//import alterar from "~/pages/financeiro/segunda-via/alterar.vue"
//import detalhe from "~/pages/financeiro/segunda-via/detalhe.vue"
//import lista from "~/pages/financeiro/segunda-via/lista.vue"
//import segundaVia from "~/pages/financeiro/segunda-via/index.vue"
//import novaLinha from '~/pages/financeiro/segunda-via/nova-linha.vue'
//import { component } from "vue/types/umd"

export default {
    path: "segunda-via",
    component: () => import("~/pages/financeiro/segunda-via/index.vue"),
    children: [
        {
            path: "",
            component: () => import("~/pages/financeiro/segunda-via/lista.vue"),
            meta: {
                isMainScreen: true,
            },
            children: [
                {
                    path: "alterar/:codigo",
                    component: () => import("~/pages/financeiro/segunda-via/alterar.vue"),
                    props: true,
                    children: [
                        {
                            path: "nova-linha",
                            component: () => import("~/pages/financeiro/segunda-via/nova-linha.vue"),
                            props: true
                        }
                    ]
                },
                
            ]
        },
        {
            path: "detalhe/:mes/:ano/:codigo",
            component: () => import("~/pages/financeiro/segunda-via/detalhe.vue")
        },
    ],
}
